<template>
  <div class="container" >
    <!-- 头部导航栏 -->
    <HeaderRegion ref="headerForm" :isShowIndex="2"></HeaderRegion>

    <div id="mainPage">
      <!--
          引入商品顶部操作栏
          region用来区分页面调用,我以文件名作为区分
      -->
      <div class="taskDetail-header">
        <TaskDetailHeader ref="taskDetailFrom" @showModel="showModel" :missionInfo="missionInfo"
                          region="hallDetail"></TaskDetailHeader>
      </div>

      <div class="shop-detail">
        <!-- 详情主要部分 -->
        <div class="shop">
          <ShopDetail ref="shopFrom" region="hallDetail" :missionInfo="missionInfo"></ShopDetail>

          <div style="background-color: #FFFFFF;padding-left: 10%;padding-bottom: 20px" v-if="missionInfo.taskstatus!=2 && (missionInfo.taskStage == 7||missionInfo.taskStage == 8)">
            <div style="height: 50px;line-height: 50px;margin-top: -20px;font-weight: bold;" v-if="missionInfo.taskStage == 7">
              待结算金额：￥{{missionInfo.payAmount}}
            </div>
            <div style="height: 50px;line-height: 50px;margin-top: -20px;font-weight: bold;" v-if="missionInfo.taskStage == 8">
              结算金额：￥{{missionInfo.payAmount}}
            </div>
          </div>

          <!--    ==============处理进度=========操作按钮=========start-->
          <div style="background-color: #FFFFFF;padding-left: 10%;padding-bottom: 20px">
            <div style="height: 50px;line-height: 50px;margin-top: -20px;font-weight: bold;" v-if="missionInfo.taskstatus!=2 && (missionInfo.taskStage == 4||missionInfo.taskStage == 5||missionInfo.taskStage == 6||missionInfo.taskStage == 8)">
              处理进度
            </div>
            <el-timeline v-if="missionInfo.taskstatus!=2 && (missionInfo.taskStage == 3||missionInfo.taskStage == 4||missionInfo.taskStage == 5||missionInfo.taskStage == 6||missionInfo.taskStage == 7||missionInfo.taskStage == 8)">
              <el-timeline-item
                v-for="(activity, index) in activities"
                :key="index"
                :icon="activity.icon"
                :type="activity.type"
                :color="activity.color"
                :size="activity.size"
                :placement="placement"
                :timestamp="activity.timestamp">
                {{activity.content}}

                <el-card
                  v-if="missionInfo.taskStage==6 && missionInfo.expressCompany!='' && missionInfo.expressCode!='' && index==2">
                  <div style="display: inline-block;width: 200px;">
                    <h4>快递公司：{{missionInfo.expressCompany}}</h4>
                    <p>快递单号：{{missionInfo.expressCode}}</p>
                  </div>
                  <div style="display: inline-block;position: absolute;top: 50%;right: 40%;">
                    <el-button type="warning" round size="mini" @click="Modifyfile">修改</el-button>
                  </div>

                </el-card>
              </el-timeline-item>
            </el-timeline>

            <div style="text-align: center;">
              <el-button type="warning" round style="width: 40%" @click="submitworks"
                         v-if="missionInfo.taskStatus == '1'">提交审核
              </el-button>
              <el-button type="warning" round style="width: 40%" @click="letterconf"
                         v-if="missionInfo.taskStage == '3'">确认通过函
              </el-button>
              <el-button type="info" round style="width: 40%"
                         v-if="missionInfo.taskStage == '4'" disabled>已确认通过函
              </el-button>
              <el-button type="warning" round style="width: 40%" @click="fillinfo" v-if="missionInfo.taskStage == '5'">
                填写快递信息
              </el-button>
              <el-button type="info" round style="width: 40%"
                         v-if="missionInfo.taskStage == '6'" disabled>已填写快递信息
              </el-button>
            </div>
          </div>
          <!--    ==============处理进度=========操作按钮=========end-->
        </div>
        <!-- 右边侧边栏 -->
        <div class="side-Bar">
          <SideNavigationBar ref="SideFrom"></SideNavigationBar>
        </div>
      </div>
    </div>

    <!--
      导入模态框 （我只是一个样式框，里面的内容需要自己填写）
      close  关闭弹框
      isShowModel  如果是true,打开弹框，false关闭
    -->
    <div class="show-model">
      <ShowModel ref="modelFrom" @close="close" title="评审进度" :isShowModel="isShowModel">
        <div slot="shop-list" class="shop-list">
          <div class="shopList" v-if="!missionInfo.worksReturnVoList || missionInfo.worksReturnVoList.length==0">
            暂无数据
          </div>
          <div class="shopList" v-for="(item,index) in missionInfo.worksReturnVoList" :key="index" v-if="missionInfo.worksReturnVoList&&missionInfo.worksReturnVoList.length>0">
            <div class="shop-img">
              <img class="shop-icon" src="../../../static/image/hallNoSubmit/task.png" v-if="missionInfo.missionType == '1'" alt/>
              <img class="shop-icon" src="../../../static/image/hallNoSubmit/zijian.png" v-if="missionInfo.missionType == '2'" alt/>
              <img class="shop-titImg" src="../../../static/image/recommendIcon.png" alt v-if="missionInfo.missionType == '2'"/>
              <img class="shop-titImg" :src="missionInfo.squarePicture" alt v-if="missionInfo.missionType == '1'"/>

            </div>
            <div class="shopDetail">
              <div class="status">
                <span style="color:#DFB876" v-if="item.worksStatus == 1 && item.worksStage == 2">待提交</span>
                <span style="color:#DFB876" v-if="item.worksStatus == 1 && item.worksStage == 3">已入围，待提交</span>
                <span style="color:#DFB876" v-if="item.worksStatus == 2">评审中</span>
                <span style="color:#DFB876" v-if="item.worksStatus == 3">审核通过</span>
                <span style="color:#DFB876" v-if="item.worksStatus == 4">已驳回</span>
                <span style="color:#DFB876" v-if="item.worksStatus == 5">已超时</span>
              </div>
              <div class="shop-name">款式名称：{{item.modelName}}</div>
              <div class="shop1">任务流水号：{{missionInfo.taskSerialCode}}</div>
              <div class="shop2">活动时间</div>
              <div class="shop1">起 {{missionInfo.missionStartTime}}</div>
              <div class="shop1">止 {{missionInfo.missionEndTime}}</div>
            </div>
            <div class="hr" v-if="index<3"></div>
          </div>

        </div>
      </ShowModel>
    </div>

    <!--    快递信息弹窗-->
    <div class="show-model">
      <ShowModel ref="modelFastFrom" @close="close" title="填写快递信息" :isShowModel="showFastModal">
        <div slot="shop-list" class="shop-list">
          <div class="shopList" style="text-align: center">
            <div class="demo-input-suffix">
              <span>快递公司：</span>
              <el-input v-model="companyname" placeholder="请填写快递公司" maxLength="100" style="width: 50%"></el-input>
            </div>
            <div style="margin-top: 20px">
              <span>快递单号：</span>
              <el-input v-model="Courierid" placeholder="请填写快递单号" maxLength="100" style="width: 50%"></el-input>
            </div>
          </div>
          <div style="text-align: center;margin-top: 40px;">
			  <!-- style="width: 40%"  style="width: 50%"-->
            <el-button type="info" round  @click="showFastModalCancel">取消</el-button>
            <el-button type="warning" round  @click="showFastModalCancelOK">填写快递信息</el-button>
          </div>

        </div>

      </ShowModel>
    </div>

    <!-- 底部展示区域 -->
    <BottomRegion ref="bottomForm"></BottomRegion>
  </div>
</template>

<script>
  import HeaderRegion from "../../components/headerRegion/headerRegion"; //引入头部导航栏
  import BottomRegion from "../../components/bottomRegion/bottomRegion"; //引入底部展示
  import TaskDetailHeader from "../../components/taskDetailHeader/taskDetailHeader"; //引入商品顶部操作栏
  import SideNavigationBar from "../../components/sideNavigationBar/sideNavigationBar"; //右边侧边栏
  import ShopDetail from "../../components/shopDetail/shopDetail"; //引入商品详情模块
  import ShowModel from "../../components/showModel/showModel";
  import config from "../../api/config"; //引入模态框
  export default {
    name: "hallDetail",
    components: {
      HeaderRegion,
      BottomRegion,
      TaskDetailHeader,
      SideNavigationBar,
      ShopDetail,
      ShowModel,
    },
    data() {
      return {
        // loading:false,
        isShowModel: false,
        missionInfo: "",
        activities: [
          {
            content: '确认通过函',
            color: '#909399',
            timestamp: ''
          }, {
            content: '平台发送协议合同',
            color: '#909399',
            timestamp: ''
          }, {
            content: '设计师签约，快递合同',
            color: '#909399',
            timestamp: ''
          }, {
            content: '平台审核，进入待结算',
            color: '#909399',
            timestamp: ''
          }, {
            content: '已结算',
            color: '#909399',
            timestamp: ''
          }
        ],
        showFastModal: false,
        showFastInfo: false,
        companyname: "",
        Courierid: "",
        placement: "top",
        canSubmit:true,
        isTrue:false,
      };
    },
    created() {
      this.id = this.$route.query.id;
      this.getTaskDetail(this.id);
    },
    watch:{
      id(n,o){
        console.log(n,o);
        this.id = n;
        this.getTaskDetail(this.id);
      },
    },
    methods: {
      showModel() {
        console.log("打开弹框");
        this.isShowModel = true;
      },
      close() {
        console.log("关闭弹框");
        this.isShowModel = false;
        this.showFastModal = false;
      },
      //获取任务详情
      async getTaskDetail(id) {
        try {
          let data = {
            id: id,
          }
          const res = await this.$http.getTaskDetails(data)
          if (res.code == 200) {
            if (res.result) {
              let result = res.result;
              if (result.taskStageList) {
                result.taskStageList.forEach((item) => {
                  if (item.taskStage == 4) {
                    this.activities[0].color = '#DFB876';
                    this.activities[0].timestamp = item.operateTime;
                  }
                  if (item.taskStage == 5) {
                    this.activities[1].color = '#DFB876';
                    this.activities[1].timestamp = item.operateTime;
                  }
                  if (item.taskStage == 6) {
                    this.activities[2].color = '#DFB876';
                    this.activities[2].timestamp = item.operateTime;
                    this.showFastInfo = true
                  }
                  if (item.taskStage == 7) {
                    this.activities[3].color = '#DFB876';
                    this.activities[3].timestamp = item.operateTime;
                  }
                  if (item.taskStage == 8) {
                    this.activities[4].color = '#DFB876';
                    this.activities[4].timestamp = item.operateTime;
                  }
                })
              }

             // result.squarePicture = result.squarePicture===null?'':result.squarePicture.indexOf("http") > -1 || result.squarePicture.indexOf("https") > -1 ? result.squarePicture : config.baseImgUrl + result.squarePicture
              result.squarePicture = result.squarePicture&&(result.squarePicture.indexOf("http") > -1 || result.squarePicture.indexOf("https") > -1 )? result.squarePicture : config.baseImgUrl + result.squarePicture
            }
            this.missionInfo = res.result
            console.log(this.missionInfo);
          } else {
            this.$message(res.message);
          }
        } catch (e) {

          throw e
        }
      },
      changeMissionInfo(missionInfo) {
        this.missionInfo = missionInfo;
        console.log(this.missionInfo)
      },
      //提交审核
      async submitworks() {
         this.isTrue = false
        let taskid = this.missionInfo.id
        let list = this.missionInfo.worksReturnVoList
        let urlList = this.missionInfo.urlList
        console.log(list,'list')
        let submitlist = urlList

        if (submitlist.length <= 0) {
          this.$message.warning('请上传pdf文件');
          return false;
        }
        list.forEach((item,index)=>{
          if(item.pdfList.length<=0){
             this.isTrue = true
             return false;
          }
        })
        if(!this.isTrue){
          this.$confirm('确认提交审核?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit(submitlist,taskid);
          }).catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消删除'
            // });
          });
        }else{
          this.$message.warning('每个款式请至少上传一个pdf文件');
        }

      },
      async submit(submitlist,taskid) {
        if (submitlist.length > 0) {
          this.canSubmit = false;
          let obj = {
            'worksStatus': 2,
            'workInfoVoList': submitlist,
            'taskId': taskid
          }
          const res = await this.$http.submitworks(obj)
          if (res.code == 200) {
            console.log('123')
            // this.loading  =true
            this.$message.success('提交审核成功', 1500);
            setTimeout(() => {
              this.$router.push({
                path: "/hall/hall",
                query: {},
              });
              this.canSubmit = true
            }, 100)
            // app.globalData.submittype = 2
          } else {
            this.$message.warning(res.message != "" ? res.message : '提交失败', 1500);
          }
        } else {
          this.$message.warning('请上传pdf文件');
        }
      },
      //确认通过函
      async letterconf() {
        try {
          let id = this.missionInfo.id
          const res = await this.$http.letterconf(id)
          console.log(res)
          if (res.code == 200) {
            let id = this.missionInfo.id
            this.$message.success(res.message, 1500);
            this.audtingtask(id)
            this.$router.go(0)

          }
        } catch (e) {
          this.$message.warning(e.data ? e.data.message : e.message, 1500);
          throw e
        }
      },
      async audtingtask(id) {
        try {
          const res = await this.$http.audtingtask(id)
          this.missionInfo = res.result
        } catch (e) {
          this.$message.warning(e.data ? e.data.message : e.message, 1500);
          throw e
        }
      },
      //填写快递信息弹窗
      fillinfo() {
        this.showFastModal = true
      },
      //填写快递信息取消
      showFastModalCancel() {
        this.showFastModal = false
      },
      // 填写快递信息确定
      showFastModalCancelOK: function () {
        if (this.companyname == '' || this.Courierid == '') {
          this.$message.warning('请填写完整的快递信息', 1500);
          return
        } else {
          this.Courierinfo()
        }
      },
      //上传快递合同
      async Courierinfo() {
        try {
          let id = this.missionInfo.id
          let obj = {
            'expressCode': this.Courierid,
            'expressCompany': this.companyname,
            'taskId': this.missionInfo.id
          }
          const res = await this.$http.Courierinfo(obj)
          console.log(res)
          if (res.code == 200) {
            this.$message.success(res.message, 1500);
            this.audtingtask(id)
          }else{
            this.$message.warning(res.message, 1500);
          }
          this.showFastModal = false;
        } catch (e) {
          this.$message.warning(e.data ? e.data.message : e.message, 1500);
          throw e
        }
      },
      //修改快递信息
      Modifyfile() {
        let value = this.missionInfo.expressCompany
        let codeid = this.missionInfo.expressCode
        this.companyname = value;
        this.Courierid = codeid;
        this.showFastModal = true;
      },
    },
  };
</script>


<style scoped>
  /deep/ .el-timeline-item__content {
    color: #909399;
  }

  .container {
    width: 100%;
  }

  .taskDetail-header {
    width: 62%;
    padding: 27px 19%;
    background: #ffffff;
  }

  .shop-detail {
    width: 62%;

    padding: 27px 19%;
    display: flex;
    align-items: flex-start;
  }

  .side-Bar {
    display: inline-block;
    width: 21.5%;
    margin: 0 0 0 3.5%;
  }

  .shop {
    width: 75%;
     min-width: 650px !important;
    display: inline-block;
  }

  .hr {
    position: relative;
    top: 20px;
    border-bottom: 1px dashed #c7c7c7;
    opacity: 1;
  }

  .shopList {
    padding: 20px 25px 20px 31px;
  }

  .shop-titImg {
    width: 90px;
    height: 90px;
    border-radius: 5px;
  }

  .shop-icon {
    width: 28px;
    height: 13px;
    position: absolute;
  }

  .shop-name {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 21px;
    color: #3a3a3a;
    opacity: 1;
  }

  .shopDetail {
    font-size: 10px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 14px;
    color: #9e9e9e;
    opacity: 1;
    width: 69%;
    display: inline-block;
  }

  .status {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 14px;
    color: #dfb876;
    opacity: 1;
    float: right;
    margin: 72px 0 0 0;
  }

  .shop-img {
    width: 30%;
    display: inline-block;
    position: relative;
  }

  .shop2 {
    margin: 9px 0 0 0;
  }

  .el-card {
    margin-top: 10px;
    width: 60%;
  }

  .el-card /deep/ .el-card__body {
    padding: 0 20px !important;
  }

  .el-timeline-item /deep/ .el-timeline-item__timestamp.is-top {
    position: absolute;
    margin-left: 200px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/hall/hallDetail.vue